import { WorkOrderRecordType } from '@xbcb/shared-types';

// Pure eligibility check for the HTS reasonability feature: reasonability is
// limited to US Consumption Entries. The isHtsReasonabilityEnabled feature gate
// is applied separately at each call site (flag first, then this check).
export const isReasonabilityApplicable = (
  workOrderType?: WorkOrderRecordType,
): boolean => workOrderType === WorkOrderRecordType.US_CONSUMPTION_ENTRY;
